import React, { useContext, useEffect, useState } from 'react'
import './Box.css'
import { useLocation, useNavigate } from 'react-router-dom';
import Globalcontext from '../../Context/Globalcontext';

const Box = (props) => {
  const navigate = useNavigate();
  const [info,setInfo] = useState();
  const [testname,setTestname] = useState();
  const a = useContext(Globalcontext);

  useEffect(()=>{
    if(props.head === "What is IQ?")
    {
      setInfo("An intelligence quotient (IQ) is a total score derived from a set of standardized tests or subtests designed to assess human intelligence .The abbreviation 'IQ' was coined by the psychologist William Stern for the German term Intelligence quotient, his term for a scoring method for intelligence tests at University of Breslau he advocated in a 1912 book.\n\nHistorically, IQ was a score obtained by dividing a persons mental age score, obtained by administering an intelligence test, by the persons chronological age, both expressed in terms of years and months. The resulting fraction (quotient) was multiplied by 100 to obtain the IQ score.[3] For modern IQ tests, the raw score is transformed to a normal distribution with mean 100 and standard deviation 15.[4] This results in approximately two-thirds of the population scoring between IQ 85 and IQ 115 and about 2.5 percent each above 130 and below 70.")
    }
    else if(props.head === "Why to Test IQ?")
    {
      setInfo("IQ testing can be helpful. The results of specific subtests often are helpful in providing evidence for one or more specific neurodevelopmental dysfunctions. IQ testing can yield highly relevant data, especially when such testing includes error analyses that pinpoint discrete breakdowns in verbal comprehension, visual spatial, fluid reasoning, working memory, processing speed.\n\n A child psychologist is valuable in identifying issues complicating or aggravating neurodevelopmental dysfunctions. That professional also can diagnose any specific psychiatric condition contributing to the clinical picture in a child with academic problems.IQ Scale Distribution")
    }
    else if(props.head === "About INIQTEST")
    {
      setInfo("INIQTEST is a live online supervised IQ test for students and professionals. Our program help student and professionals to know their accurate IQ score effortlessly and swiftly.\n\n The tricks and games suggested after testing the IQ of participant helps them to improve their IQ with fun and play..")
    }
    else if(props.head === "How to Participate")
    {
      setInfo("Under Graduate Students, Post Graduate Students and Professionals can appear for INIQTEST any time according to their convenience but for their is fixed schedule for the students studying in Grade 1 to 12 to appear for INIQTEST.")
    }
    else if(props.head === "Annual Schedule")
    {
      setInfo("Under Graduate Students, Post Graduate Students and Professionals can appear for INIQTEST any time according to their convenience but for their is fixed schedule for the students studying in Grade 1 to 12 to appear for INIQTEST.Annual Schedule for Students Studying in Grade 1 to 12\n\n<b>Registration</b>\n\nStudent can register for the test within the below mentioned period every year.\n\n1st June to 31st December\n\nTests\n\nThe test will be conducted within the below mentioned period every year.\n\n1st November to 28th February\n\nResults\n\nResults will be announced within the below mentioned period every year\n\n\n1st March to 31st March")
    }
    else if(props.head === "Pattern of the Test")
    {
      setInfo("Total Number Of Questions\n\n Total 20 questions will be randomly generated to each participant.Maximum Time Allowed\n\n Maximum 30 minutes of time will be allowed to each participant.Invigilator to Student Ratio\n\n Maximum 6 students will be supervised by 1 invigilator at a time.")
    }
    else if(props.head === "Awards/Rewards")
    {
      setInfo("Students participating in the INIQTEST will be honored and awarded based on their IQ scores as follows\n\n<b>INTERNATIONAL TOPPERS</b>\n\n<b>1st</b>\n1,00,000/-\nRupees One Lakh\n\n<b>2nd</b>\n50,000/-\nRupees Fifty Thousands\n\n<b>3rd</b>\n25,000/-\nRupees Twenty Five Thousands\n")
    }
  },[])

  const handleclickbox = ()=>{
    let rawData = {
      head: props.head,
      info: info
     
    }
    if(props.head === "Demo Test" || props.head === "Practice Test" || props.head === "Main Test")
    {
     
      a.setTestname(props.head);
      if(props.head !== "")
      {
        navigateToTest();
      }
    }
    else
    {
      navigate('/services', { state: rawData });
    }
  }
  

  const navigateToTest = () => {
   
    navigate('/test')
  };

  return (
    <div onClick={handleclickbox} className="aboutiq">
        <div
        style={{
            background: props.background
        }}
         className="box">
            {props.img}
        </div>
        <span className='boxhead'>{props.head}</span>
      </div>
  )
  
}

export default Box
